<template>
  <div class="app-content content devcontent">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header-left mb-1 pt-0 pad_top_mar_bot-5">
        <div class="container-fluid">
          <div class="row breadcrumbs-top">
            <div class="col-md-12 content-header-left px-0">
              <h3 class="content-header-title float-left mb-0">
                Live Vehicle Location
              </h3>

              <div class="breadcrumb-wrapper">
                <ol class="breadcrumb">
                  <li class="breadcrumb-item">
                    <a href="#">Vehicle Location</a>
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card content-body">
        <div class="card-header px-0 common_top_title_searchbgst_dock">
          <div class="container-fluid">
            <div class="row row fc_my-05">
              <div class="w-auto px-1 mobile-padding-0-2">
                <div
                  class="avatar bg-light-secondary rounded d-inline-flex mr-1"
                >
                  <div class="avatar-content">
                    <em
                      class="las la-search-location i_icon_st font-medium-5"
                    ></em>
                  </div>
                </div>

                <h4 class="card-title d-inline-flex ml-0 mb-0">
                  Vehicle Escalation and Geolocation Details
                </h4>
              </div>
            </div>
          </div>
        </div>
        <div class="card text-center mb-1 p-1">
          <div class="row match-height gateperformanceiconTrakingdb">
            <div
              @click="toggleActive(scenarioid[0].id)"
              class="col-6 col-sm-6 col-md-3 col-xl-2 gateperformanceicon_col_px5"
            >
              <div
                class="card text-center my_projects-bgs_co performance_projects-bgs-16 mb-1 cards boxes"
                id="box1"
                @click="handleClicked('box1')"
              >
                <div class="gateperformanceicon">
                  <div class="avatar bg-light-warning p-50 mb-1">
                    <div class="avatar-content avatar_iconsview">
                      <em class="las la-phone custom-class font-medium-10"></em>
                    </div>
                  </div>
                </div>
                <div class="card-body card_crossdock_image pt-0 pb-1 px-0">
                  <div class="timeGatetimeview">
                    <span class="avgGatetimeview">{{
                      dataPoints.enroute_stoppage
                    }}</span>
                  </div>
                  <h2 class="font-weight-bolder">Enroute Stoppage</h2>
                </div>
              </div>
            </div>
            <div
              @click="toggleActive(scenarioid[1].id)"
              class="col-6 col-sm-6 col-md-3 col-xl-2 gateperformanceicon_col_px5"
            >
              <div
                class="card text-center my_projects-bgs_co performance_projects-bgs-17 mb-1 cards boxes"
                id="box2"
                @click="handleClicked('box2')"
              >
                <div class="gateperformanceicon">
                  <div class="avatar bg-light-warning p-50 mb-1">
                    <div class="avatar-content avatar_iconsview">
                      <em class="las la-phone custom-class font-medium-10"></em>
                    </div>
                  </div>
                </div>
                <div class="card-body card_crossdock_image pt-0 pb-1 px-0">
                  <div class="timeGatetimeview">
                    <span class="avgGatetimeview">
                      {{ dataPoints.enroute_stoppage_red_zone }}</span
                    >
                  </div>
                  <h2 class="font-weight-bolder">
                    Enroute Stoppage (Red Zone)
                  </h2>
                </div>
              </div>
            </div>
            <div
              @click="toggleActive(scenarioid[2].id)"
              class="col-6 col-sm-6 col-md-3 col-xl-2 gateperformanceicon_col_px5"
            >
              <div
                class="card text-center my_projects-bgs_co performance_projects-bgs-19 mb-1 cards boxes"
                id="box3"
                @click="handleClicked('box3')"
              >
                <div class="gateperformanceicon">
                  <div class="avatar bg-light-warning p-50 mb-1">
                    <div class="avatar-content avatar_iconsview">
                      <em class="las la-phone custom-class font-medium-10"></em>
                    </div>
                  </div>
                </div>
                <div class="card-body card_crossdock_image pt-0 pb-1 px-0">
                  <div class="timeGatetimeview">
                    <span class="avgGatetimeview">{{
                      dataPoints.accident
                    }}</span>
                  </div>
                  <h2 class="font-weight-bolder">Accident Calls</h2>
                </div>
              </div>
            </div>
            <div
              @click="toggleActive(scenarioid[3].id)"
              class="col-6 col-sm-6 col-md-3 col-xl-2 gateperformanceicon_col_px5"
            >
              <div
                class="card text-center my_projects-bgs_co performance_projects-bgs-20 mb-1 cards boxes"
                id="box4"
                @click="handleClicked('box4')"
              >
                <div class="gateperformanceicon">
                  <div class="avatar bg-light-warning p-50 mb-1">
                    <div class="avatar-content avatar_iconsview">
                      <em class="las la-phone custom-class font-medium-10"></em>
                    </div>
                  </div>
                </div>
                <div class="card-body card_crossdock_image pt-0 pb-1 px-0">
                  <div class="timeGatetimeview">
                    <span class="avgGatetimeview">
                      {{ dataPoints.breakdown }}</span
                    >
                  </div>
                  <h2 class="font-weight-bolder">Breakdown Calls</h2>
                </div>
              </div>
            </div>
            <div
              @click="toggleActive(scenarioid[4].id)"
              class="col-6 col-sm-6 col-md-3 col-xl-2 gateperformanceicon_col_px5"
            >
              <div
                class="card text-center my_projects-bgs_co performance_projects-bgs-18 mb-1 cards boxes"
                id="box5"
                @click="handleClicked('box5')"
              >
                <div class="gateperformanceicon">
                  <div class="avatar bg-light-warning p-50 mb-1">
                    <div class="avatar-content avatar_iconsview">
                      <em class="las la-phone custom-class font-medium-10"></em>
                    </div>
                  </div>
                </div>
                <div class="card-body card_crossdock_image pt-0 pb-1 px-0">
                  <div class="timeGatetimeview">
                    <span class="avgGatetimeview">
                      {{ dataPoints.low_avg_speed }}</span
                    >
                  </div>
                  <h2 class="font-weight-bolder">Low Avg. Speed Maintained</h2>
                </div>
              </div>
            </div>
            <div
              @click="toggleActive(scenarioid[5].id)"
              class="col-6 col-sm-6 col-md-3 col-xl-2 gateperformanceicon_col_px5"
            >
              <div
                class="card text-center my_projects-bgs_co performance_projects-bgs-15 mb-1 cards boxes"
                id="box6"
                @click="handleClicked('box6')"
              >
                <div class="gateperformanceicon">
                  <div class="avatar bg-light-warning p-50 mb-1">
                    <div class="avatar-content avatar_iconsview">
                      <em class="las la-phone custom-class font-medium-10"></em>
                    </div>
                  </div>
                </div>
                <div class="card-body card_crossdock_image pt-0 pb-1 px-0">
                  <div class="timeGatetimeview">
                    <span class="avgGatetimeview">
                      {{ dataPoints.loading_unloading_delay }}</span
                    >
                  </div>
                  <h2 class="font-weight-bolder">
                    Loading/Unloading Delay Calls
                  </h2>
                </div>
              </div>
            </div>
          </div>
        </div>
        <section class="map-section">
          <div
            id="mapContainer"
            ref="mapContainer"
            style="height: calc(100vh - 120px); transition: width 0.3s"
          ></div>
          <div
            id="vehicleInfo"
            class="clicked-vehicle-info-container accordian"
            style="transition: width 0.3s; position: relative"
            role="tablist"
          >
            <div class="info-item info-item--span--2">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.collapse-1 variant="warning"
                  >Escalation Call Records</b-button
                >
              </b-card-header>

              <b-collapse
                id="collapse-1"
                visible
                accordion="my-accordion"
                role="tabpanel"
              >
                <div class="table-responsive">
                  <!-- <b-card class="no-padding"> -->
                  <table
                    class="table dataTableListing table-hover table-striped project_name_member_text_01 custom_doctable"
                    aria-describedby="mydesc"
                  >
                    <thead class="header-primary">
                      <th scope="col" class="text-center">CALLER NAME</th>
                      <th scope="col" class="text-center">CALLER CONTACT</th>
                      <th scope="col" class="text-center">CALL RECIPIENT</th>
                      <th scope="col" class="text-center">RECIPIENT RANK</th>
                      <th scope="col" class="text-center">CALL STATUS</th>
                      <th scope="col" class="text-center">CALL REASON</th>
                      <th scope="col" class="text-center">LEVEL</th>
                      <th scope="col" class="text-center">CREATED AT</th>
                      <th scope="col" class="text-center">SCHEDULED AT</th>
                    </thead>
                    <template v-if="selectedVehicle">
                      <tr v-for="list of selectedEscalationRecord">
                        <td data-column="CALLER NAME" class="text-left">
                          {{ formatValue(list.caller_name) }}
                        </td>
                        <td data-column="CALLER CONTACT" class="text-left">
                          {{ formatValue(list.caller_contact) }}
                        </td>
                        <td data-column="CALL RECIPIENT" class="text-left">
                          {{ list.call_recipient }}
                        </td>
                        <td data-column="RECIPIENT RANK" class="text-left">
                          {{ list.call_recipient_rank }}
                        </td>
                        <td data-column="CALL STATUS" class="text-left">
                          {{ list.call_status }}
                        </td>
                        <td data-column="CALL REASON" class="text-left">
                          {{ list.call_reason }}
                        </td>
                        <td data-column="LEVEL" class="text-left">
                          {{ list.escalation_level }}
                        </td>
                        <td data-column="CREATED AT" class="text-left">
                          {{ formatTimeStampToMonth(list.created_at) }}
                        </td>
                        <td data-column="SCHEDULED AT" class="text-left">
                          {{ formatTimeStampToMonth(list.call_scheduled_at) }}
                        </td>
                      </tr>
                    </template>
                    <template v-else>
                      <tr>
                        <td colspan="14" style="text-align: center">
                          No records found
                        </td>
                      </tr>
                    </template>
                  </table>
                  <!-- </b-card> -->
                </div>
              </b-collapse>

              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.collapse-2 varient="warning">
                  Vehicle & Escalation Info</b-button
                >
              </b-card-header>
              <b-collapse
                id="collapse-2"
                accordion="my-accordion"
                role="tabpanel"
              >
                <div class="info-content" v-if="selectedVehicle">
                  <div class="info-item">
                    <strong>Vehicle:</strong>
                    <span id="vehicleId">{{
                      selectedVehicle.vehicle_registration_number
                    }}</span>
                  </div>
                  <div class="info-item">
                    <strong>Route Path:</strong>
                    <span id="routePath">{{ selectedVehicle.route_path }}</span>
                  </div>
                  <div class="info-item info-item--span--2">
                    <strong>Scenario/Reason:</strong>
                    <span id="reason"
                      >Low Avg Speed Maintained{{
                        selectedVehicle.scenario_id
                      }}</span
                    >
                  </div>
                  <div class="info-item">
                    <strong>Driver Name:</strong>
                    <span id="vehicleId">{{
                      selectedVehicle.driver_name
                    }}</span>
                  </div>
                  <div class="info-item">
                    <strong>Driver Mobile:</strong>
                    <span id="vehicleId">{{
                      selectedVehicle.driver_mobile
                    }}</span>
                  </div>

                  <div class="info-item">
                    <strong>Origin:</strong>
                    <span id="routePath">{{ selectedVehicle.origin }}</span>
                  </div>
                  <div class="info-item">
                    <strong>Destination:</strong>
                    <span id="routePath">{{
                      selectedVehicle.destination
                    }}</span>
                  </div>
                  <div class="info-item">
                    <strong>Call Escalated Time:</strong>
                    <span id="callTime">{{
                      formatTimeStampToMonth(selectedVehicle.created_at)
                    }}</span>
                  </div>
                  <div class="info-item">
                    <strong>Speed:</strong>
                    <span id="speed">{{ selectedVehicle.speed }} km/h</span>
                  </div>
                  <div class="info-item">
                    <strong>Latitude:</strong>
                    <span id="lat">{{ selectedVehicle.lat }}° N</span>
                  </div>
                  <div class="info-item">
                    <strong>Longitude:</strong>
                    <span id="lng">{{ selectedVehicle.lng }}° E</span>
                  </div>
                </div>
                <div v-else>
                  <div>No data available</div>
                </div>
              </b-collapse>

              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.collapse-3 variant="info">
                  Vehicle Trip Details
                </b-button>
              </b-card-header>
              <b-collapse
                id="collapse-3"
                visible
                accordion="my-accordion"
                role="tabpanel"
              >
                <div class="table-responsive">
                  <!-- <b-card class="no-padding"> -->
                  <table
                    class="table dataTableListing table-hover table-striped project_name_member_text_01 custom_doctable"
                    aria-describedby="mydesc"
                  >
                    <thead class="header-primary">
                      <th scope="col" class="text-center">Trip Date</th>
                      <th scope="col" class="text-center">Route Distance</th>
                      <th scope="col" class="text-center">Route Type</th>
                      <th scope="col" class="text-center">Departure Date</th>
                      <th scope="col" class="text-center">
                        Actual Departure Date
                      </th>
                      <th scope="col" class="text-center">Arrival Date</th>
                      <th scope="col" class="text-center">
                        Acutal Arrival Date
                      </th>
                      <th scope="col" class="text-center">Shipment Type</th>
                    </thead>
                    <template v-if="selectedVehicle">
                      <tr v-for="list in selectedTripRecord">
                        <td data-column="Trip Date" class="text-left">
                          {{ formatDate(list.trip_date) }}
                        </td>
                        <td data-column="Route Distance" class="text-left">
                          {{ list.route_distance_km }} Km
                        </td>
                        <td data-column="Route Type" class="text-left">
                          {{ list.vehicle_route_type }}
                        </td>
                        <td data-column="Departure Date" class="text-left">
                          {{ formatDate(list.departure_date) }}
                        </td>
                        <td
                          data-column="Actual Departure Date"
                          class="text-left"
                        >
                          {{ formatDate(list.actual_departure_date) }}
                        </td>
                        <td data-column="Arrival Date" class="text-left">
                          {{ formatDate(list.arrival_date) }}
                        </td>
                        <td data-column="Actual Arrival Date" class="text-left">
                          {{ formatDate(list.actual_arrival_date) }}
                        </td>
                        <td data-column="Shipment Type" class="text-left">
                          {{ list.shipment_type }}
                        </td>
                      </tr>
                    </template>
                    <template v-else>
                      <tr>
                        <td colspan="14" style="text-align: center">
                          No records found
                        </td>
                      </tr>
                    </template>
                  </table>
                  <!-- </b-card> -->
                </div>
              </b-collapse>
            </div>
            <button id="closeInfo" @click="closeVehicleInfo">Close</button>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>
<script>
import { MarkerClusterer } from "@googlemaps/markerclusterer";
import axios from "axios";
import moment from "moment";
import Pagination from "vue-pagination-2";
import DatePicker from "vue2-datepicker";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import "vue2-datepicker/index.css";
import Treeselect from "@riophae/vue-treeselect";
import VueElementLoading from "vue-element-loading";
import {
  XCircleIcon,
  FileIcon,
  UploadIcon,
  DownloadIcon,
  EditIcon,
} from "vue-feather-icons";
import CONSTANT from "../../constants.js";
import { read, utils } from "xlsx";
import schema from "../../utils/schema.js";
import common_methods from "../../utils/common_methods.js";
import searchMasterNameList from "../../utils/searchMasterNameList.js";

export default {
  name: "vehicleGeolocation",
  mixins: [common_methods, searchMasterNameList],
  components: {
    Treeselect,
    DatePicker,
    VueTimepicker,
    VueElementLoading,
    Pagination,
    UploadIcon,
    FileIcon,
    XCircleIcon,
    DownloadIcon,
    EditIcon,
    Pagination,
  },
  data() {
    return {
      isLoading: false,
      map: null,
      active: false,
      infoWindow: null,
      locations2: [
        { lat: -31.56391, lng: 147.154312 },
        { lat: -33.718234, lng: 150.363181 },
        { lat: -33.727111, lng: 150.371124 },
        { lat: -33.848588, lng: 151.209834 },
        { lat: -33.851702, lng: 151.216968 },
        { lat: -34.671264, lng: 150.863657 },
        { lat: -35.304724, lng: 148.662905 },
        { lat: -36.817685, lng: 175.699196 },
        { lat: -36.828611, lng: 175.790222 },
        { lat: -37.75, lng: 145.116667 },
        { lat: -37.759859, lng: 145.128708 },
        { lat: -37.765015, lng: 145.133858 },
        { lat: -37.770104, lng: 145.143299 },
        { lat: -37.7737, lng: 145.145187 },
        { lat: -37.774785, lng: 145.137978 },
        { lat: -37.819616, lng: 144.968119 },
        { lat: -38.330766, lng: 144.695692 },
        { lat: -39.927193, lng: 175.053218 },
        { lat: -41.330162, lng: 174.865694 },
        { lat: -42.734358, lng: 147.439506 },
        { lat: -42.734358, lng: 147.501315 },
        { lat: -42.735258, lng: 147.438 },
        { lat: -43.999792, lng: 170.463352 },
      ],
      locations: [],
      scenarioid: [
        { id: [1], label: "Enroute Stoppage" },
        { id: [2], label: "Enroute Stoppage (Red Zone)" },
        { id: [3, 4, 5], label: "Accident Calls" },
        { id: [6, 7], label: "Breakdown Calls" },
        { id: [8], label: "Low Avg. Speed Maintained" },
        { id: [9, 10], label: "Loading/Unloading Delay Calls" },
      ],
      dataPoints: {
        enroute_stoppage: 0,
        enroute_stoppage_red_zone: 0,
        accident: 0,
        breakdown: 0,
        low_avg_speed: 0,
        loading_unloading_delay: 0,
      },
      phoneNumber: "9325468627",
      selectedVehicle: null,
      selectedEscalationRecord: null,
      escalationRecords: [
        {
          call_initiation_time: "",
          call_start_time: "",
          call_end_time: "",
          call_duration: "",
          caller_name: "Atul2",
          caller_contact: "Driver",
          call_recipient: "",
          call_recipient_rank: "TRIGGERED",
          call_recipient_contact: "",
          url: "",
          call_reason: "Low Avg Speed Maintained",
          escalation_level: 1,
          guid: "63A018198CEC41FFB7EF20240424162412",
          created_by: "cron",
          updated_by: "cron",
          created_at: "2024-05-22 17:57",
          updated_at: "2024-05-22 17:57",
          call_scheduled_at: "2024-05-22 15:27",
          announcement_message: "",
        },
      ],
      fields: [
        { key: "caller_name", label: "Caller Name" },
        { key: "caller_contact", label: "Caller Contact" },
        { key: "call_recipient", label: "Call Recipient" },
        { key: "call_recipient_rank", label: "Recipient Rank" },
        { key: "call_status", label: "Call Status" },
        { key: "call_reason", label: "Call Reason" },
        { key: "escalation_level", label: "Level" },
        { key: "created_at", label: "Created At" },
        { key: "call_scheduled_at", label: "Scheduled At" },
      ],
      selectedTripRecord: [],
      vehicleRecords: [
        {
          trip_date: "",
          route_distance_km: "",
          vehicle_route_type: "",
          departure_date: "",
          actual_departure_date: "",
          arrival_date: "",
          actual_arrival_date: "",
          shipment_type: "",
          is_accident: "",
          is_breakdown: "",
          is_stopped: "",
        },
      ],
      vehicle_fields: [
        { key: "trip_date", label: "Trip Date" },
        { key: "route_distance_km", label: "Route Distance" },
        { key: "vehicle_route_type", label: "Route Type" },
        { key: "departure_date", label: "Departure Date" },
        { key: "actual_departure_date", label: "Actual Departure Date" },
        { key: "arrival_date", label: "Arrival Date" },
        { key: "actual_arrival_date", label: "Actual Arrival Date" },
        { key: "shipment_type", label: "Shipment Type" },
        { key: "is_accident", label: "Is Accident" },
        { key: "is_breakdown", label: "Is BreakDown" },
        { key: "is_stopped", label: "Is Stopped" },
      ],
    };
  },
  components: {
    MarkerClusterer,
  },
  mounted() {
    this.initMap();
    this.handleClicked('box3')
    this.toggleActive(this.scenarioid[2].id)
    this.preActivatedAside()
  },
  created() {
    this.getDashboardPoints();
  },
  methods: {
    preActivatedAside() {
      const mapContainer = document.getElementById("mapContainer");
      const vehicleInfo = document.getElementById("vehicleInfo");
      vehicleInfo.classList.add("visible");
      mapContainer.style.flex = "0 0 60%";
    },
    toggleCurrentBox() {
      let allBoxes = document.querySelectorAll(".boxes");
      for (let box of allBoxes) {
        box.classList.remove("currentBox");
      }
    },
    handleClicked(id) {
      this.toggleCurrentBox();
      let currentBox = document.getElementById(id);
      currentBox.classList.add("currentBox");
    },
    getScenarioWiseData(scenario_id) {
      let url = "/stats/escalation-stats/scenario";
      this.makeRequest("POST", url, { scenario_id })
        .then((result) => {
          this.isLoading = false;
          if (result.status) {
            // console.log(result.data.data)
            let temLocation = result.data.data;
            this.locations = temLocation.map((obj) => {
              return {
                ...obj,
                lat: Number(obj.lat),
                lng: Number(obj.lng),
              };
            });
            //console.log(this.locations)
            this.initMap();
          }
        })
        .catch((e) => {
          this.displayError(e);
        });
    },
    getDashboardPoints() {
      this.isLoading = true;
      let url = "/stats/escalation-stats";
      this.makeRequest("POST", url)
        .then((result) => {
          this.isLoading = false;
          if (result.status) {
            this.dataPoints = result.data.data;
          }
        })
        .catch((e) => {
          this.displayError(e);
        });
    },
    callPhoneNumber() {
      // You can add additional logic here if needed
      // console.log("Calling phone number:", this.phoneNumber);
    },
    async initMap() {
      // Request needed libraries.
      const { Map, InfoWindow } = await google.maps.importLibrary("maps");
      const { AdvancedMarkerElement, PinElement } =
        await google.maps.importLibrary("marker");
      this.selectedVehicle = null;

      let center = { lat: 21.13866742, lng: 78.90309435 };

      if (this.locations.length) {
        center = { lat: this.locations[0].lat, lng: this.locations[0].lng };
      }

      this.map = new google.maps.Map(this.$refs.mapContainer, {
        zoom: 13,
        center,
        disableDefaultUI: true,
        mapId: "8e0a97af9386fef",
      });
      this.infoWindow = new google.maps.InfoWindow({
        content: "",
        disableAutoPan: true,
      });

      // Create an array of alphabetical characters used to label the markers.
      const labels = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";

      // Add some markers to the map.
      // console.log(this.locations)
      //console.log("++loc")
      const markers = this.locations.map((position, i) => {
        const label = position.sector_name; //labels[i % labels.length];

        const customIcon = {
          url: "https://cdn-icons-png.flaticon.com/512/2344/2344094.png", // Provide the path to your custom icon image
          scaledSize: new google.maps.Size(25, 25), // Adjust the size as needed
        };

        const iconImg =
          "https://cdn-icons-png.flaticon.com/512/2344/2344094.png";

        const pinGlyph = new google.maps.marker.PinElement({
          glyph: label,
          glyphColor: "white",
        });
        const marker = new google.maps.Marker({
          position,
          icon: customIcon,
        });
        // const marker = new google.maps.marker.AdvancedMarkerElement({
        //   position,
        //   content: pinGlyph.element,
        // });

        // markers can only be keyboard focusable when they have click listeners
        // open info window when marker is clicked
        //console.log("position")
        //console.log(position)
        marker.addListener("click", () => {
          this.infoWindow
            .setContent(`<div style="text-align: center; font-weight: bold;">${position.vehicle_registration_number} (${position.route_path})</div>    
            <div style="text-align: center; font-weight: normal;padding-top: 10px">Driver Name: ${position.driver_name ? position.driver_name : "John Doe"}</div>
            <div style="text-align: center; font-weight: bold; padding-top: 10px"><a v-on:click="callPhoneNumber" href="tel:123456789">Call to Driver</a></div>`);
          this.infoWindow.open(this.map, marker);
          this.openVehicleInfo(position);
        });

        return marker;
      });

      // Add a marker clusterer to manage the markers.
      new MarkerClusterer({ markers, map: this.map });
    },
    toggleActive(id) {
      this.active = !this.active;
      let scenario_id = [];
      for (let i = 0; i < id.length; i++) {
        scenario_id.push(id[i]);
      }
      this.getScenarioWiseData(scenario_id);
    },
    openVehicleInfo(position) {
      this.selectedEscalationRecord = null;
      this.selectedTripRecord = [];
      this.selectedVehicle = position;
      const mapContainer = document.getElementById("mapContainer");
      const vehicleInfo = document.getElementById("vehicleInfo");
      this.addVehicleDataToTable(this.selectedVehicle);
      // Example click event listener
      mapContainer.addEventListener("click", () => {
        vehicleInfo.classList.add("visible");
        mapContainer.style.flex = "0 0 60%";
      });

      // // Example close functionality
      // vehicleInfo.addEventListener('click', () => {

      // });
    },
    closeVehicleInfo() {
      const vehicleInfo = document.getElementById("vehicleInfo");
      vehicleInfo.classList.remove("visible");
      mapContainer.style.flex = "1";
    },
    addVehicleDataToTable(data) {
      // console.log(data.ct_trip_detail);
      let tripData = data.ct_trip_detail;
      let escalationData = data.ct_escalation_call_logs;
      if (tripData) {
        this.selectedTripRecord.push(tripData);
      }
      if (escalationData) {
        this.selectedEscalationRecord = escalationData;
      }
      //console.log(this.selectedTripRecord);
      // console.log(this.selectedEscalationRecord);
    },
  },
};
</script>

<style scoped>
.map-section {
  position: relative;
  display: flex;
  height: calc(100vh - 120px);
}

#map {
  height: 100%;
}

#mapContainer {
  flex: 1;
  height: 100%;
}

.clicked-vehicle-info-container {
  width: 0;
  height: 100%;
  overflow: hidden;
  background-color: #f0f0f0;
  transition: width 0.3s;
}

.clicked-vehicle-info-container.visible {
  max-height: 100%;
  overflow: auto;
  width: 40%;
  display: block;
}

.info-header {
  margin-top: 8px;
  padding-bottom: 8px;
  text-align: center;
}

.info-content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 8px;
  margin-bottom: 8px;
  overflow-y: auto;
  max-height: calc(100vh - 200px);
}

.info-item {
  display: flex;
  flex-direction: column;
  padding: 8px;
  background-color: #f9f9f9;
  border-radius: 5px;
}

.info-item span {
  margin-top: 5px;
  font-size: 14px;
  color: #555;
}

.info-item--span--2 {
  grid-column: span 2;
}

#closeInfo {
  margin-top: auto;
  padding: 10px 20px;
  background-color: #ff5c5c;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  width: 100%;
  position: relative;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
}

html,
body {
  height: 100%;
  margin: 0;
  padding: 0;
}
.cards {
  cursor: pointer;
}

.currentBox {
  background-color: black !important;
}
.active {
  background-color: #f0f0f0; /* Light grey background color */
  border: 1px solid #ccc; /* Subtle border */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.6); /* Shadow effect */
  transition: box-shadow 0.3s ease; /* Smooth transition for the shadow effect */
}

.no-padding {
  padding: 0 !important;
}

.table-responsive {
  overflow-x: auto;
}

.compact-table {
  font-size: 0.475em; /* Adjust as necessary */
}

.table-responsive {
  max-width: 100%;
  overflow-x: auto;
}
</style>
